import { useState, useCallback } from 'react';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { ChatBotData, getGetApiChatBotDataGetQueryKey, getGetApiChatBotDataListQueryKey, putApiChatBotDataRename } from '@/API';

export const useRenameChatBotData = () => {
    const queryClient = useQueryClient();
    const [loading, setLoading] = useState(false);

    const renameChatBotData = useCallback((data: ChatBotData, onDelete?: () => void) => {
        modals.openContextModal({
            modal: "TextInput",
            title: '修改名稱',
            innerProps: {
                initText: data.name,
                onConfirm: async (v) => {
                    setLoading(true)
                    try {
                        if (data.id) {
                            await putApiChatBotDataRename({
                                workspaceId: data.workspaceId,
                                id: data.id,
                                name: v
                            })
                            queryClient.invalidateQueries({ queryKey: getGetApiChatBotDataListQueryKey() })
                            queryClient.invalidateQueries({
                                queryKey: getGetApiChatBotDataGetQueryKey({
                                    id: data.id
                                })
                            })
                            notifications.show({ message: "修改成功" })
                        }
                    } catch (e) {
                        notifications.show({ message: "修改失敗", color: "red" })
                    }
                    setLoading(false)
                },
            },

        });
    }, [queryClient]);

    return {
        renameChatBotData: renameChatBotData,
        loading: loading,
    };
};